<template>
  <div>
    <div>
      <div class="tabs" v-bind:style="{ width: navWidth, }">
        <ul>
          <li class="ut-m-0"
              v-for="tab in tabs"
              :key="tab.name"
              :class="{ 'is-active': tab.isActive, 'new': tab.new }">
            <a :href="tab.href"
              v-if="gaTracking"
              v-gaEvent="{ category: tab.gacategory,
                           action: tab.getGaAction,
                           label: tab.galabel }">{{ tab.name }}</a>
            <a v-else :href="tab.href">
              {{ tab.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="ut-h-full">
      <div class="tabs-details ut-pt-4 md:ut-pt-10">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    gaTracking: {
      type: Boolean,
      required: false,
      default: true,
    },
    navWidth: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    selectedTab() {
      return this.$route ? this.tabs.find(tab => tab.href === this.$route.hash) : null;
    },
  },
  watch: {
    $route() {
      if (this.selectedTab) {
        this.selectTab(this.selectedTab);
      }
    },
  },
  mounted() {
    if (this.selectedTab) {
      this.selectTab(this.selectedTab);
    }
  },
  created() {
    this.tabs = this.$children;
    console.log(this.tabs);
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        // eslint-disable-next-line no-param-reassign
        tab.isActive = tab.href === selectedTab.href;
      });

      this.$emit('changeTabs', selectedTab.name);

      if (selectedTab.gapageview) {
        this.$helpers.gaPageView(selectedTab.gapageview);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tabs {
  @apply ut-flex ut-justify-between;
  @apply ut-items-stretch ut-overflow-hidden;
  @apply ut-overflow-x-auto ut-whitespace-no-wrap ut-scrolling-touch ut-ml-0;

  @media (max-width: 768px) {
    width: 100% !important;
  }

  ul {
    @apply ut-justify-start ut-items-center ut-max-w-full ut-flex ut-w-full;

    @screen md {
      @apply ut-flex ut-flex-grow ut-flex-shrink-0;
    }
  }

  li {
    @apply ut-relative ut-w-full;

    @screen md {
      @apply ut-pr-0;
    }

    &.new {
      &:after {
        @apply ut-top-0 ut-uppercase ut-bg-red-400 ut-text-neutral-001;
        content: "new";

        width: 37px;
        border-radius: 8px;
        font-size: 8px;
        font-weight: bold;
        letter-spacing: 0.2px;
        line-height: 14px;
        text-align: center;
        position: absolute;
        right: 3rem;
      }
    }
  }

  a {
    @apply ut-items-center ut-flex ut-justify-center ut-align-top ut-py-4 ut-text-neutral-900 ut-uppercase;
    @apply ut-text-sm;
    @apply ut-px-8 ut-py-5;
    @apply ut-border-b-4 ut-border-neutral-040;
    font-weight: 500;
  }

  .is-active a {
    @apply ut-border-b-4 ut-border-green-500 ut-text-green-400;
  }
}
</style>
